import { render, staticRenderFns } from "./CAFormPEM.vue?vue&type=template&id=4b148d2a&"
import script from "./CAFormPEM.vue?vue&type=script&lang=js&"
export * from "./CAFormPEM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b148d2a')) {
      api.createRecord('4b148d2a', component.options)
    } else {
      api.reload('4b148d2a', component.options)
    }
    module.hot.accept("./CAFormPEM.vue?vue&type=template&id=4b148d2a&", function () {
      api.rerender('4b148d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/CAFormPEM.vue"
export default component.exports